import React from "react";

const GENDERS = ["", "Female", "Male", "Prefer not to say"];
const MARITAL = ["", "Single", "Married", "Engaged", "Widowed", "Divorced", "Separated", "Prefer not to say"];

const Field = ({ label, children, wide }) => (
  <label className={`block ${wide ? "sm:col-span-2" : ""}`}>
    <span className="block text-xs font-semibold uppercase tracking-wider mb-1.5" style={{ color: "var(--sj-text-3)" }}>{label}</span>
    {children}
  </label>
);

const Toggle = ({ checked, onChange, testid, label, hint }) => (
  <label className="flex items-start gap-3 rounded-xl border p-3 cursor-pointer" style={{ borderColor: "var(--sj-border)" }}>
    <input type="checkbox" data-testid={testid} checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-4 w-4 accent-[#0B5E4E]" />
    <span><span className="block text-sm font-semibold">{label}</span><span className="block text-xs" style={{ color: "var(--sj-text-3)" }}>{hint}</span></span>
  </label>
);

export const profileExtrasFrom = (m = {}) => ({
  gender: m.gender || "", marital_status: m.marital_status || "", occupation: m.occupation || "",
  emergency_name: m.emergency_name || "", emergency_relationship: m.emergency_relationship || "", emergency_phone: m.emergency_phone || "",
  sms_opt_in: m.sms_opt_in !== false, email_opt_in: m.email_opt_in !== false,
});

export const ProfileExtraFields = ({ form, setForm, inputCls }) => {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <>
      <Field label="Gender">
        <select data-testid="profile-gender" value={form.gender} onChange={set("gender")} className={inputCls}>{GENDERS.map((g) => <option key={g} value={g}>{g || "Select…"}</option>)}</select>
      </Field>
      <Field label="Marital status">
        <select data-testid="profile-marital-status" value={form.marital_status} onChange={set("marital_status")} className={inputCls}>{MARITAL.map((g) => <option key={g} value={g}>{g || "Select…"}</option>)}</select>
      </Field>
      <Field label="Occupation" wide><input data-testid="profile-occupation" value={form.occupation} onChange={set("occupation")} maxLength={100} className={inputCls} /></Field>
      <div className="sm:col-span-2 pt-1 text-sm font-semibold" style={{ color: "var(--sj-primary)" }}>Emergency contact</div>
      <Field label="Name"><input data-testid="profile-emergency-name" value={form.emergency_name} onChange={set("emergency_name")} maxLength={100} className={inputCls} /></Field>
      <Field label="Relationship"><input data-testid="profile-emergency-relationship" value={form.emergency_relationship} onChange={set("emergency_relationship")} maxLength={60} placeholder="e.g. Spouse, Parent" className={inputCls} /></Field>
      <Field label="Phone" wide><input data-testid="profile-emergency-phone" value={form.emergency_phone} onChange={set("emergency_phone")} maxLength={30} className={inputCls} /></Field>
      <div className="sm:col-span-2 pt-1 text-sm font-semibold" style={{ color: "var(--sj-primary)" }}>How we contact you</div>
      <div className="sm:col-span-2 grid sm:grid-cols-2 gap-3">
        <Toggle testid="profile-sms-opt-in" checked={form.sms_opt_in} onChange={(v) => setForm({ ...form, sms_opt_in: v })} label="Texts from the church" hint="Reminders, updates and messages from your teams and cell group" />
        <Toggle testid="profile-email-opt-in" checked={form.email_opt_in} onChange={(v) => setForm({ ...form, email_opt_in: v })} label="Emails from the church" hint="Newsletters, course and event emails" />
      </div>
      <p className="sm:col-span-2 -mt-2 text-xs" style={{ color: "var(--sj-text-3)" }}>Login details and password-reset messages are always sent, even if you switch these off.</p>
    </>
  );
};
